import PropTypes from 'prop-types'
import React from 'react'
import styles from './nav.module.scss'
import SubLevel from 'components/Nav/subcomponents/SubLevel'
import clsx from 'clsx'

const Nav = ({ items = [], level = 1, collapse = false, className }) => {
  return (
    <div className={clsx(styles['nav'], className)}>
      <nav className={styles['nav__list']}>
        {items.map((props) => {
          //eslint-disable-next-line
          const { label_key, key } = props
          if (!label_key) return

          return (
            // eslint-disable-next-line react/jsx-key
            <SubLevel
              {...props}
              level={level}
              routeKey={key}
              collapse={collapse}
            />
          )
        })}
      </nav>
    </div>
  )
}

Nav.propTypes = {
  className: PropTypes.string,
  collapse: PropTypes.bool,
  items: PropTypes.array,
  simple: PropTypes.bool,
  open: PropTypes.bool,
  level: PropTypes.number,
}

export default Nav
